export const PinSendingMode = [
  'MAIL', 'EMAIL', 'SMS'
]
